import {
    Camera,
    Microphone,
    CAMOFF,
    MICOFF,
    RecordOFF,
    RecordON,
    RecordReady,
    ChatBubble,
    ListControl,
  } from "../../assets/icons";



const ToastMessage=(props:any)=>{

    return(
        <div className=" flex bg-[#202121]/[0.7] pt-2 pb-2 pr-3 pl-3 rounded">
           { props.imgSrc && <img
              src={props.imgSrc}
              alt="camera"
              height={20}
              width={20}
              style={{ height: "20px"  }}
              ></img>
            }
              <span className="text-sm text-white ml-2" >{props.message}</span>

        </div>
    )


}

export default ToastMessage;